import { api } from "@/APIRequests";
import type { PatientArticulatedGoalsResponse } from "@/core/types";

export async function getArticulatedGoals(
  patientId: string,
): Promise<PatientArticulatedGoalsResponse> {
  return api.carePlanTyped.get_patient_articulated_goals({
    params: { showLoader: false },
    patientId,
  });
}
